<template>
	<div class="box-title">
		<div class="level-title">
			<img src="../assets/heart.png" alt="heart" />
			<div class="text">
				<h3>Introveted Tendency</h3>
				<h2>
					あなたの内向度
				</h2>
			</div><!-- end .text -->
		</div><!-- end .level-title -->
		<div class="percentage">{{ levelResult.percentage }}<span>％</span></div>
		<div class="sentence">
			<p v-if="levelResult.percentage >= 85">
				あなたは極めて内向的な人間です。レベルを5段階に分けると、最も高い内向度のグループに属します。
			</p>
			<p v-if="levelResult.percentage < 85 && levelResult.percentage >= 65">
				あなたは内向的な人間です。レベルを5段階に分けると、2番目に内向度のグループに属します。
			</p>						
			<p v-if="levelResult.percentage < 65 && levelResult.percentage >= 50">
				あなたはやや内向的な人間です。レベルを5段階に分けると、3番目に高い内向度のグループに属します。
			</p>
			<p v-if="levelResult.percentage < 50 && levelResult.percentage >= 35">
				あなたは外向的な人間です。内向性よりやや外向度が高いことが分かりました。
			</p>
			<p v-if="levelResult.percentage < 35 && levelResult.percentage >= 15">
				あなたは外向的な人間です。内向度よりも外向度がより高いことが分かりました。
			</p>
			<p v-if="levelResult.percentage < 15 && levelResult.percentage >= 0">
				あなたは極めて外向的な人間です。レベルを5段階に分けると、最も高い外向度のグループに属します。
			</p>					
		</div><!-- sentence -->
	</div><!-- end box-title -->		
</template>

<script>


export default {
	name: 'ResultIndexLevelChart',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	methods:{

	},
	props:[

	],
	computed: {
		levelResult:function(){
			return this.$store.getters.levelResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
